import { isValid, toDate } from 'date-fns'
import { Timestamp } from 'firebase/firestore'

const validOrUndefined = (d: Date): Date | undefined =>
  isValid(d) ? d : undefined

/**
 * Coerce an unknown value to a valid Date.
 * Handles: Date, Firestore Timestamp, string, number.
 *
 * TODO: convert Timestamps to Dates at the Zod schema layer instead (ZL-660)
 */
export const toDateOrUndefined = (value: unknown): Date | undefined => {
  if (!value) return undefined
  try {
    if (value instanceof Date) return validOrUndefined(value)
    if (value instanceof Timestamp) return validOrUndefined(value.toDate())
    if (typeof value === 'string' || typeof value === 'number')
      return validOrUndefined(toDate(value))
    return undefined
  } catch {
    return undefined
  }
}
